import { styled, Typography } from '@mui/material';

export const ExerciseTotal = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(1),
}));
